import React, { useEffect, useState } from 'react';
import { BlobServiceClient } from '@azure/storage-blob';
import { WbLoader } from '@digital-engineering-experiences/wb-webcomponents';
import fileList102025 from '../utils/file-list_upd2025.json';
import fileListjan2026 from '../utils/file-list_updjan2026.json';
import fileListjuni2026a from '../utils/file-list_updjuni2026a.json';
import fileListjuni2026b from '../utils/file-list_updjuni2026b.json';

export interface BlobItem {
    name: string;
    url: string;
}

const Downloads: React.FC = () => {
    //const [files, setFiles] = useState<BlobItem[]>([]);
    const [filesupd2025, setFilesupd2025] = useState<BlobItem[]>([]);
    const [filesupdjan2026, setFilesupdjan2026] = useState<BlobItem[]>([]);
    const [filesupdjuni2026a, setFilesupdjuni2026a] = useState<BlobItem[]>([]);
    const [filesupdjuni2026b, setFilesupdjuni2026b] = useState<BlobItem[]>([]);
    //const containerName = "test";
    const storageAccount = 'c24100432stor';
    const sasToken = process.env.REACT_APP_SAS;
    const [downloading, setDownloading] = useState({});
    const [fethingFiles, setFetchingFiles] = useState(false);

    const downloadFile = async (blobName: string,containerName:string) => {
        try {
            setDownloading({
                ...downloading,
                [blobName]: true,
            }); // Start downloading

            const blobServiceClient = new BlobServiceClient(`https://${storageAccount}.blob.core.windows.net?${sasToken}`);
            const containerClient = blobServiceClient.getContainerClient(containerName);
            const blobClient = containerClient.getBlobClient(blobName);

            const downloadBlockBlobResponse = await blobClient.download(0);
            const blobUrl = window.URL.createObjectURL(await downloadBlockBlobResponse.blobBody);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', blobName);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            console.error("Download failed", error);
        } finally {
            setDownloading({
                ...downloading,
                [blobName]: false,
            }); // Finish downloading
        }
    };
    
    // use hardcoded list of files for now
    // fetching is blocked when there are multiple downloads in progress
    useEffect(() => {
        //setFiles(fileList);
        setFilesupd2025(fileList102025);
        setFilesupdjan2026(fileListjan2026);
        setFilesupdjuni2026a(fileListjuni2026a);
        setFilesupdjuni2026b(fileListjuni2026b);
    }, []);

    // useEffect(() => {
    //     const fetchBlobs = async () => {
    //         setFetchingFiles(true);
    //         const blobServiceClient = new BlobServiceClient(
    //             `https://${storageAccount}.blob.core.windows.net?${sasToken}`
    //         );
    //         const containerClient = blobServiceClient.getContainerClient(containerName);
    //         const blobItems: BlobItem[] = [];
    //         for await (const blob of containerClient.listBlobsFlat()) {
    //             blobItems.push({
    //                 name: blob.name,
    //                 url: `${containerClient.url}/${blob.name}?${sasToken}`,
    //             });
    //         }
    //         setFiles(blobItems);
    //         console.log(blobItems);
    //         setFetchingFiles(false);
    //     };
    //     fetchBlobs();
    // }, [sasToken]);

    return (
        <div className="container wb-container downloads">
            <h1>Downloads</h1>
            <p>
                <br/>
                Het netwerk wordt beheerd in het rekenpakket Infoworks ICM 2023.2.
            </p>
            <br/>
            <h5>1D en 1D/2D Ketenmodel download juni 2026</h5>
            <p>Het te downloaden netwerk bevat vier modelscenario’s:</p>
            <ol style={{ listStyleType: 'decimal' }}>
                <li>1 <b>Base:</b> huidige situatie [1D] </li>
                <li>2 <b>Scenario II:</b> toekomstige situatie [1D] </li>
            </ol>
            <p>Het derde en vierde scenario bevat de 2D objecten en aangepaste inspectieputten:</p>
            <ol style={{ listStyleType: 'decimal' }}>
                <li>3 <b>ScI - 2D prep:</b> huidige situatie [1D/2D]</li>
                <li>4 <b>ScII - 2D prep:</b> toekomstige situatie [1D/2D]</li>
            </ol>
            <p>
            De complete mesh van Tilburg is niet meegeleverd, omdat dit veel opslagruimte in beslag neemt en het netwerk hierdoor zeer traag wordt. De mesh kan zelfstandig (voor bijvoorbeeld alleen het projectgebied) worden gemaakt met behulp van het grondmodel, dat via een aanvullend netwerk is te downloaden (zie hieronder).
            </p>    
            <details open>
                <summary></summary>
                {fethingFiles && <WbLoader small />}
                {filesupdjuni2026a.length > 0 && (
                    <ul>
                        {filesupdjuni2026a.map((file) => (
                            <li key={file.name}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <button onClick={() => downloadFile(file.name,'update-juni-2026')}>{file.name}</button> {
                                        downloading[file.name] && <WbLoader small />
                                    }
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </details>  
            <h5>Aanvullende ICM netwerken</h5>
            <ol style={{ listStyleType: 'decimal' }}>
                <li>Netwerk met het hoogtemodel (AHN5)</li>
            </ol>
            <details open>
                <summary></summary>
                {fethingFiles && <WbLoader small />}
                {filesupdjuni2026b.length > 0 && (
                    <ul>
                        {filesupdjuni2026b.map((file) => (
                            <li key={file.name}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <button onClick={() => downloadFile(file.name,'update-juni-2026')}>{file.name}</button> {
                                        downloading[file.name] && <WbLoader small />
                                    }
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </details>  
            <br/>
            <h5>Achtergronddocumenten</h5>
            <ol style={{ listStyleType: 'decimal' }}>
                <li>- Excel met wijzigingen voorjaar 2026: <a href="https://c24100432stor.blob.core.windows.net/update-juni-2026/Changelog%20voorjaar%202026%20(versie%202026.3).xlsx?sp=r&st=2026-06-10T13:26:03Z&se=2028-06-10T21:41:03Z&spr=https&sv=2026-02-06&sr=b&sig=vSNCaLCZjsrnBzPT3UEnFCSjVzPK1EVZPZpCaJ6JQCc%3D" download>Changelog voorjaar 2026 (versie 2026.3).xlsx</a></li>
                <li>- Excel met vragenlijst waarmee het ketenmodel in 2025 is verbeterd: <a href="https://c24100432stor.blob.core.windows.net/update-juni-2026/20250925_Specifieke%20vragenlijst%20Ketenmodel%20v2025.1.xlsx?sp=r&st=2026-06-10T13:23:02Z&se=2028-06-10T21:38:02Z&spr=https&sv=2026-02-06&sr=b&sig=t%2FdRanypDnYnV5vdEmpFLdWGjiFsY83wFviGCdSONhs%3D" download>20250925_Specifieke vragenlijst Ketenmodel v2025.1.xlsx</a></li>
            </ol>
            <br/>
            <h5>User defined flags</h5>

            <table style={{ borderCollapse: 'collapse', width: '50%' }}>
                <thead>
                    <tr style={{ borderBottom: '1px solid #0d93f2' }}>
                        <th style={{ padding: '12px 16px', textAlign: 'left', borderBottom: '1px solid #0d93f2' }}>Naam</th>
                        <th style={{ padding: '12px 16px', textAlign: 'left', borderBottom: '1px solid #0d93f2' }}>Beschrijving</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style={{ borderBottom: '1px solid #0d93f2' }}><td style={{ padding: '12px 16px' }}>2024</td><td style={{ padding: '12px 16px' }}>Ketenmodel update 2024</td></tr>
                    <tr style={{ borderBottom: '1px solid #0d93f2' }}><td style={{ padding: '12px 16px' }}>2025</td><td style={{ padding: '12px 16px' }}>Ketenmodel update 2025</td></tr>
                    <tr style={{ borderBottom: '1px solid #0d93f2' }}><td style={{ padding: '12px 16px' }}>2026</td><td style={{ padding: '12px 16px' }}>Ketenmodel update 2026</td></tr>
                    <tr style={{ borderBottom: '1px solid #0d93f2' }}><td style={{ padding: '12px 16px' }}>WB</td><td style={{ padding: '12px 16px' }}>Aanname door W+B</td></tr>
                </tbody>
            </table>
            <br/>
            <br/>
            <h5>Vorige modelversies</h5>
            <br/>
            <br/>
            <details open>
                <summary><h2>1D model jan-2026 update</h2></summary>
                {fethingFiles && <WbLoader small />}
                {filesupdjan2026.length > 0 && (
                    <ul>
                        {filesupdjan2026.map((file) => (
                            <li key={file.name}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <button onClick={() => downloadFile(file.name,'update-jan-2026')}>{file.name}</button> {
                                        downloading[file.name] && <WbLoader small />
                                    }
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </details>       
            <br/>
            <br/>     
            <details open>
                <summary><h2>1D model okt-2025 update</h2></summary>
                {fethingFiles && <WbLoader small />}
                {filesupd2025.length > 0 && (
                    <ul>
                        {filesupd2025.map((file) => (
                            <li key={file.name}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <button onClick={() => downloadFile(file.name,'update-okt-2025')}>{file.name}</button> {
                                        downloading[file.name] && <WbLoader small />
                                    }
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </details>
            {/* <details open>
                <summary><h2>2025</h2></summary>
                {fethingFiles && <WbLoader small />}
                {files.length > 0 && (
                    <ul>
                        {files.map((file) => (
                            <li key={file.name}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <button onClick={() => downloadFile(file.name,'test')}>{file.name}</button> {
                                        downloading[file.name] && <WbLoader small />
                                    }
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </details> */}

            {/* <details>
                <summary><h2>2023</h2></summary>
                <ul>
                    <li>
                        
                    </li>
                </ul>

            </details> */}
        </div >
    );
};

export default Downloads;